import React, { useState } from "react";
import axios from "axios";
import { FaUpload } from "react-icons/fa";
import { BsFiletypeXls } from "react-icons/bs";
import "./document.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const DocumentUpload = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [progress, setProgress] = useState(0); // Track progress
  const [status, setStatus] = useState("Idle"); // Track upload status
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleFileUpload = async () => {
    if (!file) {
      setError("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    setError(null);
    setStatus("Progress");

    try {
      const response = await axios.post(
        "https://visualtable.shaleprofile.com/api/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(percentage);
            }
          },
        }
      );

      setLoading(false);
      setProgress(100);
      setSuccess(response.data.message);
      toast.success("File uploaded successfully!");
      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (err) {
      setLoading(false);
      setError("Failed to upload file. Please try again.");
      toast.error("Failed to upload file!");
      setStatus("Failed");
    }
  };

  return (
    <div className="container">
      <div className="card_upload">
        <h3>Upload Your XLSX File</h3>

        <div className="file is-normal is-boxed has-name">
          <label className="file-label">
            <input
              className="file-input"
              type="file"
              accept=".xlsx"
              onChange={handleFileChange}
              disabled={loading}
            />
            <span className="file-cta">
              <span className="file-label" style={{ color: "#0577b4" }}>
                <span className="file-icon" style={{ margin: "4px" }}>
                  <BsFiletypeXls />
                </span>
                Select a file
              </span>
            </span>
            {file && <span className="file-name">{file.name}</span>}
          </label>
        </div>

        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}

        {/* Upload Status and Progress Bar */}
        {loading && (
          <div>
            <p style={{ color: "#0577b4", fontWeight: "bold" }}>{status}</p>

            <div class="progress-container">
              <div class="progress progress-striped">
                <div
                  class="progress-bar"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
          </div>
        )}

        <div>
          <button onClick={handleFileUpload} className="btn">
            <FaUpload /> Upload
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default DocumentUpload;
